import { http } from '../index';

export const getQueueJobsList = params =>
  http
    .get('/queue-jobs', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const restartQueueJob = id =>
  http
    .post(`/queue-jobs/${id}/restart`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteQueueJob = id =>
  http
    .delete(`/queue-jobs/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

const queueJobsApi = {
  getQueueJobsList,
  restartQueueJob,
  deleteQueueJob,
};

export default queueJobsApi;
